var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "arrow-right_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.008 8.003a.731.731 0 0 0-.228-.527l-4.17-4.17c-.166-.159-.337-.229-.515-.229-.406 0-.698.286-.698.673 0 .203.082.375.21.502l1.427 1.447 1.841 1.682-1.472-.089H2.709c-.425 0-.717.292-.717.711 0 .413.292.705.717.705h7.694l1.472-.09-1.84 1.683-1.429 1.447a.699.699 0 0 0-.21.502c0 .387.293.673.699.673.178 0 .35-.07.501-.216l4.184-4.183a.728.728 0 0 0 .228-.52Z",
    fill: "currentColor"
  })));
};

export default SvgArrowRight;